export interface IManagerState {
  isManager: boolean;
  accountLocked: boolean;
  hasAccountCustomerAccess: boolean;
}

export enum Roles {
  // this is actually displayed as "Venue Manager" in Admin UI
  VenueAdmin = 'VenueAdmin',

  // Can log into any diary without being part of that account
  Support = 'Support',

  // Global access to everything
  BookItAdmin = 'BookItAdmin',

  // Sales people, Regional managers and such
  BookItStaff = 'BookItStaff',

  // These users can perform administrative actions across the account
  AccountAdmin = 'AccountAdmin',
  AccountOwner = 'AccountOwner', // this is linked to the email address in Admin -> Account -> Owner

  // This is synonymous with "Venue User" in the UI
  // No access to admin site (except for gift card section)
  VenueManager = 'VenueManager',

  // This user has access to create bookings across all venues in ABC
  ABCUser = 'AbcUser',

  // This is synonymous with "Restricted Venue User" in the UI
  // Only have access to some functions in the diary
  VenueStaff = 'VenueStaff',

  // Can export lists of accounts or venues in Admin
  BookItAccountExporter = 'BookItAccountExporter',

  // This is synonymous with "Restricted Venue User" in the UI
  // Only have access to some functions in the diary
  LoyaltySolutionAdmin = 'LoyaltySolutionAdmin',
}
